package net.gorillagroove.user

import net.gorillagroove.util.Instant;
import net.gorillagroove.api.UserId
import net.gorillagroove.db.DbUser
import net.gorillagroove.util.TimeUtil.now

class User(
    val id: UserId,
    val name: String,
    val lastActivity: Instant?,
    val createdAt: Instant,
    val yourVisibility: UserVisibilityType,
    val theirVisibility: UserVisibilityType,
) {
    fun hasRecentActivity(currentTime: Instant = now()): Boolean {
        if (lastActivity == null) {
            return false
        }
        return (currentTime - lastActivity).inWholeDays < 90
    }
}

internal fun DbUser.toUser() = User(id, name, lastActivity, createdAt, yourVisibility.asEnumeratedType(), theirVisibility.asEnumeratedType())
internal fun List<DbUser>.toUsers() = this.map { it.toUser() }
